import React from 'react'
import Link from 'gatsby-link'
import classNames from 'classnames'


const Footer = ({ location }) => (
    <div
        className={classNames(
            'footer',
            { 'footer--light': location.pathname === '/' }
        )}
        style={{ paddingTop: '30px' }}
    >
        <div className="credits" style={{ marginTop: '0px' }}>
            <p style={{ paddingTop: '0px' }}>
                Copyright © {new Date().getFullYear()}. Todos los derechos reservados - Dismocan
            </p>
        </div>
    </div>
)

export default Footer



// WEBPACK FOOTER //
// ./src/layouts/Footer/index.js